import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { loadingActions } from '../../redux/actions';
import { ShowButton } from './BugReport.styles';
import { Translate } from '../i18n/i18n';

export default () => {
    
    const dispatch = useDispatch();
    
    const open = useCallback(() => {
        dispatch(loadingActions.showBugReport(true));
    },[dispatch]);


    return <ShowButton title={Translate('bugreport.title')} onClick={()=>{open()}} />;

};